module.exports = __webpack_public_path__ + "img/hr-steam-engine-V-shadow.008cdb1b.png";